<template>
  <div class="main-finished">
    <div v-if="!error" class="content-finished">
      <b-spinner v-if="!finished" class="speener-waiting" label="Text Centered"></b-spinner>
      <b-icon v-else class="finished" stacked icon="check"></b-icon>
      <h3 :class="{'finishing': finished }">
        {{ messages[indexMessage] }} {{ finished ? secondsToRefresh + " segundos..." : "" }}
      </h3>
    </div>
    <div v-else class="content-finished">
      <b-icon class="finished error" variant="danger" stacked icon="x-circle"></b-icon>
      <h3 class="finishing">
        {{ $t('ops-aconteceu-algo-inesperado') }}
      </h3>
      <label>{{ $t('se-o-problema-persistir-por-favor-entre-em-contato-com-o-suporte-pentagro') }}</label>
    </div>
  </div>
</template>

<script>
import Mediator from '../../utilities/Mediator';

export default {
  name: "Applying-Settings",
  data() {
    return {
      indexMessage: 0,
      success: false,
      error: false,
      finished: false,
      secondsShoindMessage: 3000,
      secondsToRefresh: 3,
      updatetingFinished: false,

      messages: [
        this.$t('analizando-configuracoes-do-indicador'),
        this.$t('ajustando-seu-posicionamento'),
        this.$t('verificando-dados-do-coletor'),
        this.$t('falta-pouco'),
        this.$t('tudo-pronto-atualizando-tela-em')
      ]
    }
  },

  methods: {
    startAnimation(){
      setTimeout(() => {
        if(this.indexMessage == this.messages.length - 2 && !this.success){
          this.startAnimation()
          return;
        }

        this.indexMessage++
        
        if(this.indexMessage == this.messages.length - 1){
          this.finished = true; 
          setTimeout(() => {
            this.finalize()
          }, 300);
        }
        else
          this.startAnimation();
      }, this.secondsShoindMessage);
    },

    finalize(){
      setTimeout(() => {
        this.secondsToRefresh--;
        if(this.secondsToRefresh == 0){
          document.location.reload()
        }
        else
          this.finalize();
      }, 1000);
    }
  },

  mounted() {
    Mediator.notify(this, "init-finisher");
    this.startAnimation();
  },
}
</script>

<style scoped>

.content-finished{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 125px;
}

h3{
  margin-top: 50px;
}

h3.finishing{
  margin-top: 0px;
}

.speener-waiting {
  color: #ff5f00;
  font-size: 30px;
  height: 50px;
  width: 50px;
}

.finished {
  color: #0d0;
  width: 100px;
  padding: 0;
}

.finished.error{
  width: 60px;
  margin-bottom: 10px;
}
</style>